
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfo3X = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 48,
  width: 48,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "4 4 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm0 3.538a1.358 1.358 0 1 1-1.358 1.358A1.364 1.364 0 0 1 12 7.538zm1.421 8.586a.389.389 0 0 0 .39-.388l-.007-.76a.389.389 0 0 0-.389-.388h-.389v-3.225a.389.389 0 0 0-.389-.39h-2.059a.389.389 0 0 0-.388.39v.764c0 .215.174.39.389.39h.388v2.065h-.389a.389.389 0 0 0-.388.388v.765c0 .215.174.39.389.39h2.842z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg height=\"48\" width=\"48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"4 4 16 16\">     <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm0 3.538a1.358 1.358 0 1 1-1.358 1.358A1.364 1.364 0 0 1 12 7.538zm1.421 8.586a.389.389 0 0 0 .39-.388l-.007-.76a.389.389 0 0 0-.389-.388h-.389v-3.225a.389.389 0 0 0-.389-.39h-2.059a.389.389 0 0 0-.388.39v.764c0 .215.174.39.389.39h.388v2.065h-.389a.389.389 0 0 0-.388.388v.765c0 .215.174.39.389.39h2.842z\" fill=\"var(--theme-primary, #810ea9)\"></path>    </svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/info@3x.aeeda469fd9d3e414552060b15bb447c.svg"),
        {
          React: SvgInfo3X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      